import * as serviceContext from '../services/serviceContext';
import { BASE_URL_ADMIN, BASE_URL_M_ADMIN } from '../config';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';

export async function getStatus(id) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/managelogin/getstatus/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateStatus(data) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/managelogin/updatestatus`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function forceLogout(data) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/managelogin/forcelogout`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}